'use client';

import { useEffect, useRef } from 'react';
import { motion, useInView, useAnimation } from 'framer-motion';

import { cn } from '@eliadmin/core/src/utils/style-utils';

interface Props {
  children: React.ReactNode;
  width?: 'fit-content' | 'full';
  className?: string;
}

export const Reveal = ({ children, width = 'full', className }: Props) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  const mainControls = useAnimation();

  useEffect(() => {
    if (isInView) {
      mainControls.start('visible');
    }
  }, [isInView]);

  return (
    <div ref={ref} className={cn('relative', width === 'full' ? 'w-full' : 'w-fit', className)}>
      <motion.div
        variants={{
          hidden: { opacity: 0, y: 100 },
          visible: { opacity: 1, y: 0 },
        }}
        initial="hidden"
        animate={mainControls}
        transition={{ duration: 0.75, delay: 0.25 }}
      >
        {children}
      </motion.div>
    </div>
  );
};
